<template>
  <q-separator class="q-ma-xs" />
  <q-item
    v-for="link in educationalZone"
    :key="link.text"
    v-ripple
    clickable
    @click="link.url ? openURL(link.url) : $router.push({ name: link.name })"
  >
    <q-item-section avatar>
      <q-icon color="grey" :name="link.icon" />
    </q-item-section>
    <q-item-section>
      <q-item-label>
        {{ link.text }}
      </q-item-label>
    </q-item-section>
  </q-item>
</template>

<script setup>
const props = defineProps({
  educationalZone: Array,
});

const openURL = (link) => {
  window.open(link);
};
</script>
